// Just a small change to test the deployment process
import PackageCard from "./PackageCard";
import AddonCard from "./AddonCard";

export default function Solutions() {
  return (
    <section className="solutions" id="solutions">
      <div className="container">
        <div className="section-title">
          <h2>Complete Digital Solutions</h2>
          <p>Choose from our comprehensive packages or customize with add-ons</p>
        </div>

        {/* Part 1: Packaged Solutions */}
        <div className="solutions-section">
          <div className="section-header">
            <h3 className="section-subtitle">Packaged Solutions</h3>
            <p className="section-description">
              {/* <span id="noteline"><u>Note:</u> Domain Name + hosting support + Domain Name Email Service  + SSL certificate additional cost </span> */}
            </p>
          </div>

          {/* <div className="solutions-tabs">
            <button className="tab-btn active">Website + Email</button>
            <button className="tab-btn">With AI Chatbot</button>
            <button className="tab-btn">With CRM</button>
          </div>
 */}
          <div className="tab-content active" id="website-tab">
            <div className="package-grid">
              <PackageCard
                title="Digital Identity"
                price="Starting at ₹ 11,600/-"
                subtitle="Perfect for basic digital presence!"
                features={[
                  "5 User Interfaced professional SPA (Mobile Responsive Design)",
                  "3 to 5 Business Emails (As per open-source terms & conditions)",
                  "Google My Business Setup",
                  "Lead Capture Form + Email Forward",
                  "Social Media Integration (Providing links for access)",
                  "1 months Support"
                ]}
              />

              <PackageCard
                title="Dynamic Suite"
                price="Starting at ₹ 38,400/-"
                subtitle="Solution for growthing enterprises!"
                accent={true}
                badge="MOST POPULAR"
                features={[
                  "7-10 User Interfaces with 2-3 dynamic interfaces (Pages/Section)",
                  // "Total Email Space 50GB with upto 300 email creation",
                  "Google My Business Setup",
                  "Social Media Integration (Providing links for access)",
                  "Lead Capture Form + Chatbot Widget on website (Accessed by Telegram App on Mobile+ user driven dedicated dashboard on website)",
                  "Cloud Hosting + 6 Months Support "
                ]}
              />

              <PackageCard
                title="Enterprise-grade solution!"
                price="Starting at ₹ 85,000/-" //₹85,000
                subtitle="For futuristic enterprises!"
                features={[
                "15-20 User Interfaced website with dynamic pages",
                //"Total Email Space 50GB",
                "Google My Business Setup",
                "Chatbot integrtion (for website, facebook, instagram, telegram) for Lead capturing (Botpress open-source, no recurring charges)",
                "Lead Capture Form",
                "Social Media Integration (Providing links for access)",
                "1 Year Free Cloud Hosting (As per terms & conditions of open-source) + Support "
                ]}
              />
            </div>
          </div>
        </div>

        {/* Part 2: Add-ons */}
        <div className="solutions-section addons-section">
          <div className="section-header">
            <h3 className="section-subtitle">Add-on Services</h3>
            <p className="section-description">
              Enhance your existing website with these powerful features
            </p>
            <div className="addon-note">
              <span className="note-icon">💡</span>
              Perfect for businesses who already have a website
            </div>
          </div>

          <div className="addons-grid">
            {/* AI Chatbots */}
            <div className="addon-category">
              <h4 className="category-title">AI & Chatbots</h4>
              <div className="addon-items">
                <AddonCard
                  title="Basic AI Chatbot"
                  price="₹16,000"
                  period="setup + (optional) ₹2,000/month"
                  description="Offers 24X7 automated visitor assistance, business information delivery, and lead capture."
                  features={[
                    "Website integration",
                    "Up to 15 information based pre-defined FAQ intents",
                    "Basic Natural Language Processing",
                    "Social Media Integration (Providing links for access)",
                    "Email lead capture",
                    "1 day training & setup",
                    "Monthly performance report"
                  ]}
                  badge="STARTER"
                />

                <AddonCard
                  title="Pro NLP Chatbot"
                  price="₹27,000"
                  period="setup + 45 days support"
                  description="Multi-channel 24/7 automated customer support"
                  features={[
                    "Website + Facebook Messenger + Instagram DM",
                    "Up to 25 information based pre-defined FAQ intents",
                   "Google Sheets + auto-response email to user",
                    "Basic dashboard with message classification",
                    "Social Media Integration (Providing links for access)",
                    "3 days online training",
                    "Monthly performance report"
                  ]}
                  badge="BEST VALUE"
                />
                <AddonCard
                  title="Custom Chatbot"
                  price="Complexity   Based "
                  period="setup + monthly charges"
                  description="Multi-channel 24/7 automated customer support"
                  features={[
                    "LLM Supported Chatbots",
                    "Monthly performance report",
                    "Additional features as per discussion"
                    
                  ]}
                  badge="ADVANCE PLAN"
                />

             {/*    <AddonCard
                  title="Rasa Enterprise Chatbot"
                  price="₹25,000"
                  period="setup + ₹6,500/month"
                  description="Custom-trained AI model for complex business workflows"
                  features={[
                    "Custom AI model training",
                    "Complex workflow automation",
                    "API integrations",
                    "Voice interface option",
                    "Dedicated support & updates"
                  ]}
                  accent={true}
                /> */}
              </div>
            </div>

            {/* Business Tools */}
            <div className="addon-category">
              <h4 className="category-title">Business Tools</h4>
              <div className="addon-items">
                <AddonCard
                  title="Google My Business Setup"
                  price="₹3,000"
                  period="one-time"
                  description="Google Profile Creation"
                  features={[
                    "Profile Creation & Verification",
                    "Accurate Business Information Setup (Name, Address, Phone, Website)",
                    "Business Description & Operating Hours Setup",
                    "Business Category & Service Offerings Optimization",
                    "Upload of product/services Images",
                    "1-year maintenance"
                  ]}
                  badge="QUICK SETUP"
                />
                <AddonCard
                  title="Professional Email Setup"
                  price="₹5,500"
                  period="one-time"
                  description="Business email with your domain name"
                  features={[
                    "Up to 5 email accounts",
                    "5 GB storage",
                    "Webmail access",
                    // "Mobile configuration",
                    "Spam protection",
                    "1-year maintenance"
                  ]}
                  badge="QUICK SETUP"
                />
                <AddonCard
                  title="Appointment Scheduler"
                  price="₹8,500"
                  period="setup + (optional) ₹1,500/month"
                  description="Automated booking system for your services"
                  features={[
                    "Booking form",
                    "Calendar integration",
                    "Automated reminders (Email)",
                    "Video call booking",
                    "Google Meet integration"
                    
                    // "Payment gateway integration",
                    // "Customer dashboard"
                  ]}
                />

                {/* <AddonCard
                  title="Issue Tracker System"
                  price="₹12,000"
                  period="setup + ₹3,500/month"
                  description="Complete customer support ticket management"
                  features={[
                    "Ticket management dashboard",
                    "Priority-based queuing",
                    "Customer portal",
                    "Knowledge base integration",
                    "Performance analytics",
                    "Team collaboration tools"
                  ]}
                /> */}
              </div>
            </div>
          </div>

          <div className="addon-footer">
            <p className="footer-note">
              💰 <strong>Special Offer:</strong> Book 3+ add-ons and get 10% discount on total cost
            </p>
            {/* <p className="footer-note">
              🔄 All monthly add-ons include 30-day free trial
            </p> */}
          </div>
        </div>
      </div>
    </section>
  );
}